import { IStepItem } from "models/Component";
import { IOption, ITabSwitch } from "models/Form";
import { IJoinDocsItem } from "models/HaulPay";
import { BROKER_ITEMS } from "./haulpay-broker";
import { CARRIER_ITEMS } from "./haulpay-carrier";
import { INVITED_CARRIER_ITEMS } from "./haulpay-invited-carrier";
import { routes } from "./routes";

export const APPLY_HAULPAY_DESCRIPTION_LIST: IStepItem[] = [
  {
    id: 1,
    name: "Apply for Factoring or Digital Payments",
    description: "Please make sure to confirm all of the following information."
  },
  {
    id: 2,
    name: "Account",
    description: ""
  },
  {
    id: 3,
    name: "Docs",
    description: ""
  },
  {
    id: 4,
    name: "Summary",
    description: ""
  }
];

export const BUSINESS_TYPE_LIST = [
  {
    id: 0,
    label: "Carrier",
    value: "carrier"
  },
  {
    id: 1,
    label: "Broker",
    value: "broker"
  }
];

export const BUSINESS_LISTS = [
  {
    id: 0,
    businessType: "shipper",
    subtitle: "",
    haulPayItems: []
  },
  {
    id: 1,
    businessType: "invited-carrier",
    subtitle: "Factoring and Pay",
    haulPayItems: INVITED_CARRIER_ITEMS
  },
  {
    id: 2,
    businessType: "carrier",
    subtitle: "Factoring and Pay",
    haulPayItems: CARRIER_ITEMS
  },
  {
    id: 3,
    businessType: "broker",
    subtitle: "Factoring and Pay",
    haulPayItems: BROKER_ITEMS
  }
];

export const STATUS_LIST = [
  {
    id: 0,
    label: "Incomplete",
    value: "incomplete"
  },
  {
    id: 1,
    label: "Pending",
    value: "pending"
  },
  {
    id: 2,
    label: "Declined",
    value: "declined"
  },
  {
    id: 3,
    label: "Document Issue",
    value: "doc-issue"
  },
  {
    id: 4,
    label: "Approved",
    value: "approved"
  }
];

export const PAYMENT_DATA = [
  {
    id: 0,
    label: "ACH (***** 1617)",
    value: "ach1617"
  }
];

export const JOIN_DOCS_TYPE_LIST: IJoinDocsItem[] = [
  {
    title: "Business Owner(s) Driver's License/Passport",
    content: "Haulpay will require anyone's ID who is listed on the Articles of Incorporation.",
    category: "driver_license"
  },
  {
    title: "Articles of Incorporation",
    content:
      "Upload your articles of incorporation OR any DBA paperwork you filled with your state if a sole proprietor.",
    category: "incorporation"
  },
  {
    title: "Certificate of brokerage BMC 84/85",
    content: "OR proof of bond",
    category: "certificate"
  },
  {
    title: "W9 for the Brokerage",
    content: "OR IRS Tax ID#",
    category: "w9"
  },
  {
    title: "Voided Business Check",
    content:
      "OR Bank Letter or Bank Statement that lists your business name, address, full account and routing number. You may skip this step if you already connected your account via PLAID in the previous step",
    category: "voided_check"
  }
];

export const JOIN_SUMMARY_PLACE_LIST = [
  {
    id: 0,
    label: "Organic Search/Google",
    value: "organic_search"
  },
  {
    id: 1,
    label: "Google Ad",
    value: "google_ad"
  },
  {
    id: 2,
    label: "Facebook Ad",
    value: "facebook_ad"
  },
  {
    id: 3,
    label: "Instagram Ad",
    value: "instagram_ad"
  },
  {
    id: 4,
    label: "Industry Publication/Press",
    value: "industry_publication_press"
  },
  {
    id: 5,
    label: "Other",
    value: "other"
  }
];

export const COMPANY_TYPE = [
  {
    id: 0,
    label: "MC#",
    value: "mc"
  },
  {
    id: 1,
    label: "DOT#",
    value: "dot"
  },
  {
    id: 2,
    label: "TAX ID#",
    value: "tax_id"
  }
];

export const CREDIT_TAB_ITEMS: ITabSwitch[] = [
  {
    id: 0,
    label: "Check Credit",
    value: "check-credit",
    link: routes.HAULPAY_CREDIT_CHECK_CREDIT
  },
  {
    id: 1,
    label: "My Customers",
    value: "my-customers",
    link: routes.HAULPAY_CREDIT_MY_CUSTOMERS
  }
];

export const JOIN_HAULPAY_STEP_LIST: IStepItem[] = [
  {
    id: 1,
    name: "Create Info",
    description: "Please make sure to confirm all of the following information."
  },
  { id: 2, name: "Account", description: "" },
  { id: 3, name: "Docs", description: "" },
  { id: 4, name: "Summary", description: "" }
];

export const CREDIT_LIST = [
  {
    value: "needs_review",
    label: "Being Reviewed"
  },
  {
    value: "pending",
    label: "Pending"
  },
  {
    value: "approved",
    label: "Approved"
  },
  {
    value: "declined",
    label: "Declined"
  }
];

export const CO_BROKER_ALLOWED_LIST: IOption[] = [
  {
    id: 0,
    label: "No Acknowledgment On File",
    value: "NO_ACKNOWLEDGMENT_ON_FILE"
  },
  {
    id: 1,
    label: "Approved",
    value: "APPROVED"
  },
  {
    id: 2,
    label: "Acknowledgment Received",
    value: "ACKNOWLEDGMENT_RECEIVED"
  },
  {
    id: 3,
    label: "Declined",
    value: "DECLINED"
  }
];

export interface FR_GENERATED_ATTACHMENT {
  id: number;
  label: string;
  value: string;
  fetchDocument?: () => Promise<any>;
}

export const FR_DEFAULT_ATTACHMENTS_LIST: FR_GENERATED_ATTACHMENT[] = [
  { id: 0, label: "Collated Billing PDF", value: "collated" },
  { id: 1, label: "Invoice", value: "invoice" },
  { id: 2, label: "Carrier’s Invoice", value: "invoice_payment_profile" }
];
